import React, { useEffect } from 'react';
import { RouteComponentProps, useHistory, useParams } from 'react-router-dom';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';
import { getEntity, cancelEntity } from './scheduling.reducer';
import { useDispatch } from 'react-redux';

export const SchedulingCancelDialog = (props: RouteComponentProps<{ id: string }>) => {
  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const schedulingEntity = useAppSelector(state => state.scheduling.entity);
  const updateSuccess = useAppSelector(state => state.scheduling.updateSuccess);

  const handleClose = () => {
    props.history.push('/scheduling' + props.location.search);
  };

  const dispatch = useDispatch();

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const confirmCancel = () => {
    dispatch(cancelEntity(schedulingEntity));
  };

  return (
    <Modal isOpen toggle={handleClose}>
      <ModalHeader toggle={handleClose} data-cy="schedulingDeleteDialogHeading">
        <Translate contentKey="fleetSenseApp.scheduling.cancel.title">Confirm cancel operation</Translate>
      </ModalHeader>
      <ModalBody id="fleetSenseApp.scheduling.cancel.question">
        <Translate contentKey="fleetSenseApp.scheduling.cancel.question" interpolate={{ id: schedulingEntity.id }}>
          Are you sure you want to delete this Scheduling?
        </Translate>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={handleClose}>
          <FontAwesomeIcon icon="arrow-left" />
          &nbsp;
          <Translate contentKey="entity.action.back">Voltar</Translate>
        </Button>
        <Button id="app-confirm-delete-scheduling" data-cy="entityConfirmDeleteButton" color="danger" onClick={confirmCancel}>
          <FontAwesomeIcon icon="ban" />
          &nbsp;
          <Translate contentKey="entity.action.cancel">Cancelar</Translate>
        </Button>
      </ModalFooter>
    </Modal>
  );
};
